import enCommon from './locales/en/common.json'
import enCc from './locales/en/cc.json'
import enNav from './locales/en/nav.json'
import enDashboard from './locales/en/dashboard.json'
import enDietaries from './locales/en/dietaries.json'
import enAllergens from './locales/en/allergens.json'
import enAutopilotSettings from './locales/en/autopilotSettings.json'
import enEmma from './locales/en/emma.json'
import enMarketplace from './locales/en/marketplace.json'
import enAllergenDietary from './locales/en/allergenDietary.json'
import enPayments from './locales/en/payments.json'
import enCateringConfirmation from './locales/en/cateringConfirmation.json'
import enAuthentication from './locales/en/authentication.json'

import nlCommon from './locales/nl/common.json'
import nlCc from './locales/nl/cc.json'
import nlNav from './locales/nl/nav.json'
import nlDashboard from './locales/nl/dashboard.json'
import nlDietaries from './locales/nl/dietaries.json'
import nlAllergens from './locales/nl/allergens.json'
import nlMarketplace from './locales/nl/marketplace.json'
import nlAllergenDietary from './locales/nl/allergenDietary.json'
import nlPayments from './locales/nl/payments.json'
import nlCateringConfirmation from './locales/nl/cateringConfirmation.json'
import nlAuthentication from './locales/nl/authentication.json'

import deCommon from './locales/de/common.json'
import deCc from './locales/de/cc.json'
import deNav from './locales/de/nav.json'
import deDashboard from './locales/de/dashboard.json'
import deDietaries from './locales/de/dietaries.json'
import deAllergens from './locales/de/allergens.json'
import deEmma from './locales/de/emma.json'
import deMarketplace from './locales/de/marketplace.json'
import deAllergenDietary from './locales/de/allergenDietary.json'
import dePayments from './locales/de/payments.json'
import deCateringConfirmation from './locales/de/cateringConfirmation.json'
import deAuthentication from './locales/de/authentication.json'

import itCommon from './locales/it/common.json'
import itCc from './locales/it/cc.json'
import itNav from './locales/it/nav.json'
import itDashboard from './locales/it/dashboard.json'
import itDietaries from './locales/it/dietaries.json'
import itAllergens from './locales/it/allergens.json'
import itEmma from './locales/it/emma.json'
import itMarketplace from './locales/it/marketplace.json'
import itAllergenDietary from './locales/it/allergenDietary.json'
import itPayments from './locales/it/payments.json'
import itCateringConfirmation from './locales/it/cateringConfirmation.json'
import itAuthentication from './locales/it/authentication.json'

export const resources = {
  en: {
    cc: enCc,
    common: enCommon,
    Nav: enNav,
    dashboard: enDashboard,
    dietaries: enDietaries,
    allergens: enAllergens,
    autopilotSettings: enAutopilotSettings,
    emma: enEmma,
    marketplace: enMarketplace,
    allergenDietary: enAllergenDietary,
    payments: enPayments,
    cateringConfirmation: enCateringConfirmation,
    authentication: enAuthentication,
  },
  nl: {
    cc: nlCc,
    common: nlCommon,
    Nav: nlNav,
    dashboard: nlDashboard,
    dietaries: nlDietaries,
    allergens: nlAllergens,
    marketplace: nlMarketplace,
    allergenDietary: nlAllergenDietary,
    payments: nlPayments,
    cateringConfirmation: nlCateringConfirmation,
    authentication: nlAuthentication,
  },
  de: {
    cc: deCc,
    common: deCommon,
    Nav: deNav,
    dashboard: deDashboard,
    dietaries: deDietaries,
    allergens: deAllergens,
    emma: deEmma,
    marketplace: deMarketplace,
    allergenDietary: deAllergenDietary,
    payments: dePayments,
    cateringConfirmation: deCateringConfirmation,
    authentication: deAuthentication,
  },
  it: {
    cc: itCc,
    common: itCommon,
    Nav: itNav,
    dashboard: itDashboard,
    dietaries: itDietaries,
    allergens: itAllergens,
    emma: itEmma,
    marketplace: itMarketplace,
    allergenDietary: itAllergenDietary,
    payments: itPayments,
    cateringConfirmation: itCateringConfirmation,
    authentication: itAuthentication,
  },
} as const
